import React from "react";
import "./myPatientsViewTableHeader.scss";
import {
  APPLICABLE_ROLE,
  HEADERLIST,
} from "../../../DashboardAppointmentsView/Constant";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import { USER_ROLE } from "../../../../Util/constants";

const MyPatientsViewTableHeader = (props) => {
  const { headerList, openMenuList, displayNormalFilterList } = props;

  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);

  // Helper methods ==>

  const getClassName = (hl) => {
    let name = "col-md-3";
    if (hl.title === HEADERLIST.STATUS) {
      name = "col-md-2";
    } else if (hl.title === HEADERLIST.DATETIME) {
      name = "col-md-3 pl-2";
    } else if (hl.title === HEADERLIST.ACTION) {
      name = "col-md-1 pl-0 pr-4";
    }

    return name;
  };

  // <===

  // Display UI ===>

  const displayMyPatientsViewTableHeader = () => {
    return (
      <div className="mypatients-view-table-header">
        <div className="row header d-none d-sm-none d-md-flex">
          {headerList?.map((hl, ind) => (
            <div className={getClassName(hl)} key={ind}>
              <span>{hl.title}</span>
              {hl.filter_icon && (
                <span style={{ marginLeft: "10px", position: "relative" }}>
                  {hl.title === HEADERLIST.DOCTORNAME &&
                  userType !== APPLICABLE_ROLE.STAFF &&
                  doctorRole !== USER_ROLE.DOCTOR_ADMIN &&
                  doctorRole !== USER_ROLE.RESOURCE_ADMIN ? null : (
                    <img
                      src={hl.filter_icon}
                      alt=""
                      style={{ marginBottom: "3px", cursor: "pointer" }}
                      onClick={() => openMenuList(hl)}
                    />
                  )}
                  {hl.show_filter && displayNormalFilterList(hl)}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

  // <===

  return <>{displayMyPatientsViewTableHeader()}</>;
};

export default MyPatientsViewTableHeader;
